module.exports = __webpack_public_path__ + "img/loader.1fa94dea.svg";